import axiosInstance from "api/axios";
import { Product } from "types/product.type";
export interface PaginatedProducts {
  data: Product[];
  total: number;
  page: number;
  limit: number;
}

export const productService = {
  // get all products
  getAll: async (params: {
    page?: number;
    limit?: number;
    name?: string;
    reference?: string;
    category?: string;
    subcategory?: string;
    status?: string;
    isPromo?: string;
  }): Promise<PaginatedProducts> => {
    const response = await axiosInstance.get("/products", { params });
    return response.data;
  },

  // get specific product
  getById: async (id: number): Promise<Product> => {
    const response = await axiosInstance.get(`/products/${id}`);
    return response.data;
  },

  // get archived products
  getArchived: async (): Promise<Product[]> => {
    const response = await axiosInstance.get("/products/archived");
    return response.data;
  },

  // create product
  create: async (data: Partial<Product> | FormData): Promise<Product> => {
    const isFormData = data instanceof FormData;
    const response = await axiosInstance.post("/products", data, {
      headers: isFormData ? { "Content-Type": "multipart/form-data" } : {},
    });
    return response.data;
  },

  // update product
  update: async (
    id: number,
    data: Partial<Product> | FormData
  ): Promise<Product> => {
    const isFormData = data instanceof FormData;
    const response = await axiosInstance.put(`/products/${id}`, data, {
      headers: isFormData ? { "Content-Type": "multipart/form-data" } : {},
    });
    return response.data;
  },

  // delete product
  delete: async (id: number): Promise<void> => {
    await axiosInstance.delete(`/products/${id}`);
  },

  // get stats for a all products
  getStats: async () =>
    await axiosInstance.get("/products/stats").then((res) => res.data),

  // get stats for a specific product
  getProductStats: async (
    productId: number,
    period: "day" | "week" | "month" = "day"
  ) =>
    await axiosInstance
      .get(`/products/${productId}/stats?period=${period.toUpperCase()}`)
      .then((res) => res.data),
};
